import React, { useEffect, useRef, useState } from "react"
import { Link } from "gatsby"
import { Spin as Hamburger } from "hamburger-react"
import { StaticImage } from "gatsby-plugin-image"
import { Helmet } from "react-helmet"
import useScrollPosition from "../../utilities/use-scroll-position"
import NavItems from "./nav-items"
import AdjustLink from "../adjust-link"

const MenuMobile = ({ onDownloadClick }) => {
  const { scrollY } = useScrollPosition()
  const [blackBg, setBlackBg] = useState(false)
  const [showNav, setShowNav] = useState(false)
  const [menuPosition, setMenuPosition] = useState(0)

  const [openMobileMenu, setOpenMobileMenu] = useState<any>(null)

  const topMobileMenuRef = useRef(null)

  useEffect(() => {
    if (scrollY >= 80) {
      setBlackBg(true)
    } else {
      setBlackBg(false)
    }
  }, [scrollY])

  const toggleNav = (show: boolean) => {
    // @ts-ignore
    const topMobileMenuHeight = topMobileMenuRef.current.clientHeight
    setMenuPosition(topMobileMenuHeight)
    setShowNav(show)
  }

  const handleOpenMenuClick = (menuItem: string) => {
    setOpenMobileMenu((current) => (current === menuItem ? null : menuItem))
  }

  return (
    <>
      <Helmet bodyAttributes={{ class: showNav ? "overflow-hidden" : "" }} />
      <div
        className={`inner-container fixed-top w-full mb-[-100px] block xl:hidden mobile-menu${
          blackBg || showNav ? " background-menu" : ""
        }`}
      >
        {showNav && (
          <nav
            className='mobile-nav left-0 py-2 px-12'
            style={{
              top: `${menuPosition}px`,
              height: `calc(100vh - ${menuPosition}px)`,
            }}
          >
            <NavItems
              openMobileMenu={openMobileMenu}
              onOpenMenuClick={handleOpenMenuClick}
            />
            <div className='mt-auto mb-auto'>
              <AdjustLink
                topMenu={true}
                className='glow-animation hero-cta-btn w-full'
              >
                get the app
              </AdjustLink>
            </div>
          </nav>
        )}
        <div
          className='flex justify-between items-center'
          ref={topMobileMenuRef}
        >
          <div className='log-nav flex flex-1'>
            <div className='pl-0 p-5 flex justify-center items-center space-x-1'>
              <Link to={"/"}>
                <StaticImage
                  src='../../images/logo.png'
                  alt='Free Slots - Quick Hit Slots'
                  width={120}
                />
              </Link>
              <div className='blog-link'>
                <Link
                  to='/blog'
                  className='text-[#008AFF] text-[15px] font-bold'
                >
                  BLOG
                </Link>
              </div>
            </div>
          </div>
          <AdjustLink topMenu={true} menuUrl={"https://app.adjust.com/1075bfuj_10ts9y6v_10gwxyj5"} className={`invisible min-w-[135px] ${!showNav ? "!visible" : ""}`}>
            <StaticImage
              className="mr-6"
              src="../../images/cta.png"
              alt="Play Now"
              width={150}
            />
          </AdjustLink>
          <div className='flex space-x-3 pr-5'>
            <div>
              <Hamburger
                size={30}
                color='white'
                onToggle={(show) => toggleNav(show)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MenuMobile
